import React from 'react'

export default (props: any) => (
  <svg {...props} width="66" height="51" viewBox="0 0 66 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M65.04 16.952H0.220001V33.504H65.04V16.952Z" fill="#0052B4" />
    <path d="M65.04 33.504H0.220001V50.16H65.04V33.504Z" fill="#D80027" />
    <path d="M65.04 0.400024H0.220001V16.952H65.04V0.400024Z" fill="white" />
    <path d="M65.5 0.5H0.5V50.5H65.5V0.5Z" stroke="#9F9D9D" />
    <path d="M20.3 9.90002H7.29999V18.2H20.3V9.90002Z" fill="#0052B4" />
    <path
      d="M7.29999 16.5V18.7C7.29999 23.7 13.8 25.2 13.8 25.2C13.8 25.2 20.3 23.7 20.3 18.7V16.5L18.1 18.7L13.8 15.4L9.49999 18.7L7.29999 16.5Z"
      fill="#F0F0F0"
    />
  </svg>
)
